export default "__VITE_ASSET__BDfm9BiL__"